import React from 'react';
import gsap from 'gsap';
// styles
import styles from './styles.module.css';
// config
import { ELEMENT_TYPE } from '../config/constants';
// components
import DetailsComponent from '../Details';
import Room from '../RoomInteraction/Rooms/Room';
// data
import roomsData from '../data/rooms';

export default class SpaComponentLoader extends React.Component {
  
  constructor(props) {
    super(props);

    const { data, type } = this.props;

    // load specific data
    this.currentData = data;
    this.nextData = {};

    this.state = {
      currentDetailComponentData: this.currentData,
      nextDetailComponentData: this.nextData,
      prevRoomData: type === ELEMENT_TYPE.ROOM ? roomsData[this.currentData.links.previous.id] : null,
      currentRoomData: this.currentData,
      nextRoomData: type === ELEMENT_TYPE.ROOM ? roomsData[this.currentData.links.next.id] : null,
    }
  }

  back() {
    const { onExitCompleted, classesToHide, from } = this.props;
    // [Animations on Exit ]
    const timeline = gsap.timeline({
      onComplete: () => {
        onExitCompleted();
      }
    });
    
    timeline.to(`.detail-container-from-${from}`, { maskPosition: '0 -100%', duration: 1, ease: 'power2.inOut' }, 0);
    if (classesToHide) {
      timeline.to(classesToHide, { duration: 1, opacity: 1, ease: 'power2.inOut' }, 0);
    }
  }

  showNext(type, id) {
    const dataByType = require(`../data/${type}s`).default;
    
    const nextData = dataByType[id];

    this.setState({ nextDetailComponentData: nextData });

    return nextData;
  }

  getNewRoomData(roomId) {
    const nextData = roomsData[roomId];

    this.setState({ nextRoomData: nextData });

    return nextData;
  }

  componentDidMount() {
    const { classesToHide, from } = this.props;
    // [Animations on Enter ]
    gsap.to(`.detail-container-from-${from}`, { maskPosition: '0 100%', duration: 1, ease: 'power2.inOut' });
    if (classesToHide) {
      gsap.to(classesToHide, { duration: 1, opacity: 0, ease: 'power2.inOut' });
    }
  }

  render() {
    const { type, from } = this.props;

    return (
      <div className={`detail-container-from-${from} ${styles.detailContainer}`}>
      {[
        ELEMENT_TYPE.MOMENT,
        ELEMENT_TYPE.PRODUCT,
        ELEMENT_TYPE.DESIGNER]
        .includes(type) &&
          <DetailsComponent
            data={this.state.currentDetailComponentData}
            nextData={this.state.nextDetailComponentData}
            type={type}
            back={() => { this.back(); }}
            from={from}
            getNextData={(elemType, elemId) => { return this.showNext(elemType, elemId); }}
          />
        }
        {type === ELEMENT_TYPE.ROOM &&
          <Room
            data={this.state.currentRoomData}
            nextData={this.state.nextRoomData}
            prevData={this.state.prevRoomData}
            back={() => { this.back(); }}
            getNewRoom={(roomId) => { return this.getNewRoomData(roomId); }}
          />
        }
      </div>
    )
  }
}
